var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgOpalGemOutline = function SvgOpalGemOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 728 728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301 72.5L365.5 53H385.5L416.5 57L432.5 63.5L468 91.5L504 128L524.5 159L544 196.5L554 216L567 249.5L580 287.5L584.5 311.5L586.5 336.5L588 384V418.5L586 440.5L581.5 463L572 496.5L561 530.5L548.5 564L539 579.5L520.5 601.5L489.5 628.5L457.5 650L418.5 666.5L388 673.5H360L342.5 675L330 673.5L308 666.5L281.5 655L225.5 623L211 609.5L184 573.5L180.5 569.5L164 529.5L152 497.5L141.5 443.5L143 416L140 363L143 310.5L147.5 294.5L167 234.5L185 193L225 128L263 98.5L301 72.5Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgOpalGemOutline);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/status/opal-gem-outline.1ef1894b6def47cc808032e4fd84feb1.svg";